import {uniqueId} from 'lodash'
import projectTypes from '@/constants/projectTypes'

const inputs = [
  {
    label: 'Clients Nickname',
    type: 'select',
    options: [],
    listLabel: 'nickName',
    model: 'client',
    getValue: (value = {}) => value._id,
    searchable: true,
    required: true,
    searchableBy: 'nickName'
  },
  {
    label: 'Project name',
    model: 'name',
    autofocus: true,
    required: true
  },
  {
    label: 'Type of Service',
    type: 'select',
    options: [],
    listLabel: 'name',
    model: 'typeServiceProject',
    searchable: true,
    searchableBy: 'name',
    style: {
      textTransform: 'none'
    }
  },
  {
    label: 'Project Type',
    model: 'projectType',
    type: 'radio',
    options: projectTypes,
    resetErrors: true,
    listLabel: 'title',
    hideSubproject: true,
    isHideRow: false
  },
  {
    title: 'Include in KPI',
    type: 'checkbox',
    hideSubproject: true,
    model: 'includeOfKpi'
  },
  {
    label: 'Project funding source',
    type: 'textarea',
    height: '70px',
    model: 'includeOfKpiComment',
    show: 'includeOfKpi',
    hideTextarea: true
  },
  {
    label: 'Amount, AED',
    format: 'number',
    model: 'currentAmount',
    totalAmount: 'amount',
    popup: '$residue',
    zeroIsNotValid: true,
    required: true,
    resetErrors: true,
    hideSubproject: true
  },
  {
    label: 'Fact, AED',
    format: 'number',
    model: 'factValue',
    zeroIsNotValid: true,
    hideSubproject: true,
    haveFact: true,
    notMore: 'currentAmount'
  },
  {
    title: 'Comments',
    type: 'accordion',
    model: 'managerComment',
    placeholder: 'Enter text...',
    height: '116px',
    grid: {
      gridTemplateRows: '1fr',
      gridGap: 0
    }
  },
  {
    label: 'Project manager',
    type: 'select',
    options: [],
    listLabel: 'username',
    model: 'projectManager',
    searchable: true,
    searchableBy: 'username'
  },
  {
    label: 'Business consultant',
    type: 'select',
    options: [],
    listLabel: 'username',
    model: 'businessConsultant',
    searchable: true,
    searchableBy: 'username'
  },
  {
    title: 'Project description',
    type: 'accordion',
    model: 'projectDescription',
    placeholder: 'Enter text...',
    height: '140px',
    grid: {
      gridTemplateRows: '1fr',
      gridGap: 0
    }
  },
  {
    title: 'Users',
    propRequired: true,
    required: true,
    type: 'userContainer',
    model: 'kpiHelpUsers',
    autofocus: true,
    haveFact: true
  },
  {
    label: 'Tags',
    type: 'selectTag',
    model: 'tags',
    options: [],
    grid: {
      gridTemplateColumns: '1fr',
      alignItem: 'center',
      gridGap: '10px'
    },
    hideSubproject: true
  }
]

const prefix = 'input_project_'
const projectInputs = inputs.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export default projectInputs



// WEBPACK FOOTER //
// ./src/constants/InputsSettings/projectInputs.js